module.exports = __webpack_public_path__ + "static/Amelie_Brochu-a5eb71c22728af2b70ada7f3ab1c7ac7.webp";